enum FormStateType {
    Readonly,
    Create,
    Edit,
}

export default FormStateType;
